/**
 * メディアタイプ判定ユーティリティ
 */

/**
 * ファイルが動画かどうかを判定する
 */
export function isVideoFile(filename: string, mimeType?: string): boolean {
  // MIMEタイプでの判定
  if (mimeType?.startsWith("video/")) {
    return true;
  }

  // 拡張子での判定
  const ext = filename.split(".").pop()?.toLowerCase();
  const videoExtensions = [
    "mp4",
    "webm",
    "mov",
    "avi",
    "mkv",
    "flv",
    "wmv",
    "m4v",
  ];
  return videoExtensions.includes(ext || "");
}

/**
 * Attachmentが動画かどうかを判定する
 *
 * 新API では Attachment / FirstAttachment が camelCase に変わり、
 * Attachment は extension を持つが FirstAttachment は持たないため、
 * 拡張子は url からも推定するフォールバックを入れている。
 */
export function isVideoAttachment(attachment: {
  url?: string | null;
  mimeType: string;
  extension?: string;
}): boolean {
  const filename = attachment.extension
    ? `dummy.${attachment.extension}`
    : (attachment.url ?? "");
  return isVideoFile(filename, attachment.mimeType);
}
